module.exports = __webpack_public_path__ + "img/DiezMil.496c0b82.jpg";